//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { OpKind } from '@taquito/taquito'
export default {
  name: 'SellTokenDialog',
  props: {
    project: {
      type: Object,
      default: null,
    },
    complete: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    userTokens: [],
    agree: false,
    confirmation: false,
  }),
  computed: {
    userAddress() {
      return this.$store.getters.userAddress
    },
  },
  watch: {
    dialog(v) {
      if (this.userAddress && v) {
        this.loadUserTokens()
      }
    },
  },
  methods: {
    openHelpWallet() {
      this.dialog = false
      this.$refs.helpWalletDialog.handleOpen()
    },
    async loadUserTokens() {
      try {
        this.loading = true
        const request = {
          method: 'GET',
          url: `/api/tokens/wallet/` + this.userAddress,
          params: {
            projectId: this.project.id,
          },
        }
        const resp = await this.$axios(request)
        this.userTokens = resp.data.tokens
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    async listTokens() {
      const { marketAddress } = this.$config
      try {
        this.confirmation = false
        this.loading = true

        const operators = []
        let transactions = []

        const fa2 = await this.$globals.tezos.wallet.at(
          this.project.fa2_address
        )
        const market = await this.$globals.tezos.wallet.at(marketAddress)

        for (const t of this.userTokens) {
          if (t.shouldList) {
            if (!t.listPrice || t.listPrice < 0.0001) {
              t.shouldList = false
              continue
            }
            operators.push({
              add_operator: {
                owner: this.userAddress,
                operator: marketAddress,
                token_id: t.token_id,
              },
            })
            transactions.push({
              kind: OpKind.TRANSACTION,
              ...market.methods
                .create_ask(
                  1,
                  this.project.fa2_address,
                  t.listPrice * 1000000,
                  t.token_id
                )
                .toTransferParams(),
            })
          }
        }

        if (operators.length > 0) {
          transactions = [
            {
              kind: OpKind.TRANSACTION,
              ...fa2.methods.update_operators(operators).toTransferParams(),
            },
          ].concat(transactions)
        }

        const batch = await this.$globals.tezos.wallet.batch(transactions)
        const op = await batch.send()
        await op.confirmation(1)

        this.loading = false
        this.confirmation = true
        this.dialog = false
        this.$store.dispatch('addSnackbar', {
          text: `Your tokens have been listed!`,
        })
        this.complete()
      } catch (e) {
        this.loading = false
        this.$store.dispatch('addSnackbar', {
          text: `Failed to list tokens. Please try again later.`,
          type: 'error',
        })
        console.error('Unable to purchase token', e)
        if (e?.message && e?.message?.includes('ABORTED_ERROR')) {
          this.disconnectWallet()
        }
      }
    },
    async connectWallet() {
      this.loading = true

      try {
        const userAddress = await this.$globals.connectWallet()
        const userAlias = await this.$globals.resolveAddressToName(userAddress)
        this.$store.commit('INIT_USER_WALLET', {wallet: userAddress, alias:userAlias})
        this.$store.dispatch('logTerms', { wallet: userAddress, version:this.$config.termsVersion })

        // await axios({
        //   method: 'post',
        //   url: '/api/termsLog',
        //   data: {
        //     userAddress: this.state.userAddress,
        //     version: this.state.termsVersion,
        //     application: 'PixelDebates',
        //   },
        // })
        this.loading = false
        this.loadUserTokens()
      } catch (e) {
        console.error('Unable to connect wallet', e)
        this.loading = false
      }
    },
    async disconnectWallet() {
      await this.$globals.disconnectWallet()
      this.$store.commit('INIT_USER_WALLET', { wallet: null, alias: null })
    },
  },
}
